import { useDispatch, useSelector } from 'react-redux';
import { getMerchantUsers, deleteMerchantUser, cleanError, inviteUser, updateUserRole, swapOwnerRole, restoreMerchantUser, resendInvite } from './actions';
import { UserManagementSelectors } from './selectors';

export const useUserManagement = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(UserManagementSelectors.getLoading),
    error: useSelector(UserManagementSelectors.getError),
    errorInfo: useSelector(UserManagementSelectors.getErrorInfo),
    allMerchantUsers: useSelector(UserManagementSelectors.getAllMerchantUsers),
    deleteSuccess: useSelector(UserManagementSelectors.getDeleteSuccess),
    restoreSuccess: useSelector(UserManagementSelectors.getRestoreSuccess),
    swapOwnerSuccess: useSelector(UserManagementSelectors.getSwapOwnerSuccess),
    inviteLoading: useSelector(UserManagementSelectors.getInviteLoading),
    inviteError: useSelector(UserManagementSelectors.getInviteError),
    inviteErrorInfo: useSelector(UserManagementSelectors.getInviteErrorInfo),
    getMerchantUsers: (page?: number, pageSize?: number, filters?: { email?: string; name?: string }) =>
      dispatch(getMerchantUsers(page, pageSize, filters)),
    deleteMerchantUser: (merchantUserId: number) => dispatch(deleteMerchantUser(merchantUserId)),
    restoreMerchantUser: (merchantUserId: number) => dispatch(restoreMerchantUser(merchantUserId)),
    updateUserRole: (userId: number, role: string) => dispatch(updateUserRole(userId, role)),
    swapOwnerMerchantUser: (merchantUserId: number) => dispatch(swapOwnerRole(merchantUserId)),
    resendInviteSuccess: useSelector(UserManagementSelectors.getResendInviteSuccess),
    cleanError: () => dispatch(cleanError()),
    inviteUser: (fullName: string, email: string, role: string) => dispatch(inviteUser({ fullName, email, role })),
    resendInvite: (merchantUserId: number) => dispatch(resendInvite(merchantUserId)),
  };
};
